import {
  SET_SNACKBAR,
  CLOSE_SNACKBAR,
  SET_WINDOW_SIZES,
  SET_PREV_PAGE,
  SET_SIDEBAR_STATE,
  CLOSE_COOKIES_SNACKBAR
} from './types'
import { resetAuthToken } from 'utils/auth/actions'


export function setSnackbar(message, type = 'success') {
  return function action(dispatch) {
    dispatch({
      type: SET_SNACKBAR,
      payload: {
        message: message,
        type: type
      }
    })
  }
}

export function checkErrorStatus(code) {
  return function action(dispatch) {
    if (code === 401) {
      dispatch(setSnackbar('Auth token is expired', 'error'))
      dispatch(resetAuthToken())
    }
  }
}

export function closeCookiesSnackbar() {
  return function action(dispatch) {
    localStorage.setItem('cookiesSnack', true)
    dispatch({
      type: CLOSE_COOKIES_SNACKBAR
    })
  }
}

export function closeSnackbar() {
  return function action(dispatch) {
    dispatch({
      type: CLOSE_SNACKBAR
    })
  }
}


export function windowResize() {
  return function action(dispatch) {
    dispatch({
      type: SET_WINDOW_SIZES
    })
  }
}

export function setPrevPage(prevPage) {
  return function action(dispatch) {
    dispatch({
      type: SET_PREV_PAGE,
      payload: {
        prevPage
      }
    })
  }
}

export function setSidebarIsOpen(isOpenSidebar) {
  return function action(dispatch) {
    dispatch({
      type: SET_SIDEBAR_STATE,
      payload: {
        isOpenSidebar
      }
    })
  }
}
